export default "__VITE_ASSET__$XL0wMgw__"